module.exports = __webpack_public_path__ + "static/media/VALWIN_LOGO.9556a555.png";